module.exports = __webpack_public_path__ + "static/media/cuttlery.451f6db9.svg";